import { apiRequest } from "../lib/apiClient";
import { cachedQuery } from "../lib/queryCache";
import type {
  EffectiveEntitlement,
  ProductCatalog,
  UsageBalance,
} from "../types/auth";

export interface EntitlementGateway {
  getSummary(): Promise<EntitlementSummary>;
  getUsage(): Promise<UsageBalance>;
  getCatalog(): Promise<ProductCatalog>;
  getEffective(): Promise<EffectiveEntitlement>;
}

export interface EntitlementSummary {
  balance: UsageBalance;
  catalog: ProductCatalog;
  effective: EffectiveEntitlement;
}

export const entitlementGateway: EntitlementGateway = {
  getSummary() {
    return cachedQuery(
      "entitlements:summary",
      (signal) =>
        apiRequest<EntitlementSummary>("/entitlement-summary", { signal }),
      10_000,
    );
  },

  getUsage() {
    return cachedQuery(
      "entitlements:usage",
      (signal) => apiRequest<UsageBalance>("/usage", { signal }),
      10_000,
    );
  },

  getCatalog() {
    return cachedQuery(
      "entitlements:catalog",
      (signal) => apiRequest<ProductCatalog>("/product-catalog", { signal }),
      60_000,
    );
  },

  getEffective() {
    return cachedQuery(
      "entitlements:effective",
      (signal) => apiRequest<EffectiveEntitlement>("/entitlements", { signal }),
      10_000,
    );
  },
};
